const areaMap = {
  input: "Input",
  processes: "Processes",
  climate_and_culture: "Culture & Climate",
};

export const getAreaName = (key) => areaMap[key] || key;